import { bl_t2t_audit_trail_event_RowCLass } from "../../dbschema/bl_t2t_audit_trail_event.model";
import { BaseContainerModel } from "../base-container.model";

export class T2TAuditTrailContainerModel extends BaseContainerModel {
  bl_t2t_audit_trail_event: bl_t2t_audit_trail_event_RowCLass =
    new bl_t2t_audit_trail_event_RowCLass();
}
